import React, {useEffect, useState} from "react";
import {useDevice} from "../components/device/DeviceProvider";
import {Link, useLocation, useNavigate} from "react-router-dom";
import Layout from "../layout/Layout";
import "../../style/order/order_list.scss";
import {fetchPost, post} from "../utils/FetchUtil";
import {useLoading} from "../components/loading/LoadingProvider";
import {isBeforeDate, isNotEmpty} from "../utils/CommonUtil";
import {isQrType, isSealType} from "../const/GiftSendTypeConst";
import TemplateListModal from "../modal/TemplateListModal";
import QrFormatSettingModal from "../modal/QrFormatSettingModal";
import ProcessConfirmModal from "../modal/ProcessConfirmModal";
import {toast} from "react-toastify";
import {isCardDesignTemp, isMessageTemp, isQrSettingTemp, isWrapTemp} from "../const/TemplateConst";
import {Button, Image} from "react-bootstrap";
import OrderDetailTemplate from "./OrderDetailTemplate";
import {OrderPngDownload, OrderUrlSendHistory} from "./OrderOnlineSendArea";
import {url} from "../utils/UrlsUtil";
import {img} from "../utils/ImageUtil";
import {useAuth} from "../components/auth/AuthProvider.tsx";
import DeliveryDateTimeInput from "../components/input/DeliveryDateTimeInput.tsx";
import {isRakutenSiteSection} from "../const/SiteSectionConst.ts";


const OrderInputListPage:React.FC = () => {
    // @ts-ignore
    const { isMobile } = useDevice();
    const { loginDto } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const breadcrumbList = ["未発送のご注文"];
    const { showLoading, hideLoading } = useLoading();
    const [errorList, setErrorList] = useState([]);
    const [orderList, setOrderList] = useState<OrderInputLineDto[]>([]);

    const [showTempListModal, setShowTempListModal] = useState(false);
    const [searchTemplateDto, setSearchTemplateDto] = useState<OrderInputTemplateDto | undefined | null>(undefined);

    const [showQrSettingModal, setShowQrSettingModal] = useState(false);
    const [selectedQrSettingDto, setSelectedQrSettingDto] = useState<OrderInputTemplateDto | null | undefined>(undefined);

    const [commitOrderLineDto, setCommitOrderLineDto] = useState<OrderInputLineDto | null>(null);
    const [showCommitConfirmModal, setShowCommitConfirmModal] = useState(false);
    const [commitConfirmMsg, setCommitConfirmMsg] = useState("入力完了をすると出荷準備になるため、<br />データの変更はできません。<br /><br />よろしいでしょうか？");
    const [sendMailOnCommit, setSendMailOnCommit] = useState(true);
    useEffect(() => {
        initPage();
    }, [loginDto]);
    useEffect( () => {
        setErrorList([]);
    }, [orderList]);
    useEffect(() => {
        setShowQrSettingModal(selectedQrSettingDto !== undefined && selectedQrSettingDto !== null);
    }, [selectedQrSettingDto]);
    useEffect(() => {
        setShowTempListModal(searchTemplateDto !== undefined && searchTemplateDto !== null);
    }, [searchTemplateDto]);
    useEffect(() => {
        initPage();
    }, []);

    const initPage = () => {
        showLoading();
        post<any>({
            action: "/api/order/input",
            data: {},
        })
            .then((data) => {
                if(data !== null && isNotEmpty(data["order_line_list"])){
                    setOrderList(data["order_line_list"]);
                }else{
                    setOrderList([]);
                }
            })
            .catch((reason) => {
                console.log(reason)
                setOrderList([]);
            })
            .finally(() => {
                hideLoading();
            });
    };

    const handleClickUpdate = () => {
        const getLastRakutenOrder = async () =>{
            showLoading();
            try{
                setErrorList([]);
                const data = await fetchPost({
                        action: "/api/order/rakuten/fetch",
                    data: {},
                });
                if(data !== null){
                    setOrderList(data["order_line_list"]);
                }
            }catch (e) {
                // @ts-ignore
                setErrorList([e.message]);
            }finally {
                hideLoading();
            }
        }
        getLastRakutenOrder().finally(()=>{});
    }

    const handleClickDetailTemplate = (dto:OrderInputTemplateDto | null | undefined) => {
        if(isQrSettingTemp(dto?.template_kbn)){
            setSelectedQrSettingDto(dto);
        }else{
            setSearchTemplateDto(dto);
        }
    }

    const handleClickEntryMyDesign = (dto:OrderInputTemplateDto | null | undefined) => {
        const encodeParams = encodeURIComponent(dto?.order_slipnumber + ";" + dto?.order_detailnumber);
        if(isCardDesignTemp(dto?.template_kbn)){
            navigate(`/mydesign/card/?ord=${encodeParams}`, { state: { from: location.pathname } });
        }else {
            navigate(`/template/input/${dto?.template_kbn}/?ord=${encodeParams}`, {state: { from: location.pathname } });
        }
    }

    const handleDeallocatedTemplate = (dto:OrderInputTemplateDto | null | undefined) => {
        if(dto !== null && dto !== undefined){
            updateOrderDetailTemplate(dto);
        }
    }

    const handleSelectedTemplate = (dto: OrderInputTemplateDto) => {
        setSearchTemplateDto(undefined);
        if(dto.template_id === -1){
            if(isNotEmpty(dto.order_slipnumber)){
                const encodeParams = encodeURIComponent(dto?.order_slipnumber + ";" + dto?.order_detailnumber);
                if(isCardDesignTemp(dto?.template_kbn)){
                    navigate(`/mydesign/card/?ord=${encodeParams}`, {state: { from: location.pathname } });
                }else {
                    navigate(`/template/input/${dto?.template_kbn}/?ord=${encodeParams}`, {state: { from: location.pathname } });
                }
            }else{
                if(isCardDesignTemp(dto?.template_kbn)){
                    navigate(`/mydesign/card/`, {state: { from: location.pathname } });
                }else {
                    navigate(`/template/input/${dto?.template_kbn}`, {state: { from: location.pathname } });
                }
            }
        }else{
            updateOrderDetailTemplate(dto);
        }
    }

    const handleQrSettingSaved = (entry_dto:any) => {
        setSelectedQrSettingDto(undefined);
        showLoading();
        post<any>({
            action: "/api/template/qr_settings/entry",
            data: entry_dto,
        })
            .then((data) => {
                updateOrderDetailTemplate(data);
            })
            .catch((reason) => {
                // @ts-ignore
                setErrorList([reason.message]);
            })
            .finally(() => {
                hideLoading();
            });
    }

    const updateOrderDetailTemplate = (template_dto: OrderInputTemplateDto) => {
        const newOrderList = orderList.map(order => {
            const newDetailList = order.detail_list?.map(dtl => {
                if (dtl.slipnumber === template_dto.order_slipnumber &&
                    dtl.detailnumber === template_dto.order_detailnumber) {
                    //updatedDto = order as OrderInputLineDto;
                    const updatedDtl = { ...dtl };
                    if (isWrapTemp(template_dto.template_kbn)) {
                        updatedDtl.noshi_template_dto = template_dto;
                    } else if (isCardDesignTemp(template_dto.template_kbn)) {
                        template_dto.ondemand_card_order = dtl.card_template_dto.ondemand_card_order;
                        updatedDtl.card_template_dto = template_dto;
                    } else if (isMessageTemp(template_dto.template_kbn)) {
                        updatedDtl.message_template_dto = template_dto;
                    } else if (isQrSettingTemp(template_dto.template_kbn)) {
                        updatedDtl.qr_template_dto = template_dto;
                    }
                    return updatedDtl;
                }
                return dtl;
            });
            return { ...order, detail_list: newDetailList };
        });
        setOrderList(newOrderList);
    }

    const onClickCommit = ( orderLineDto: OrderInputLineDto ) => {
        setCommitOrderLineDto(orderLineDto);
        setSendMailOnCommit(true);
        if(orderLineDto.paper_item_type && !isRakutenSiteSection(loginDto?.site_section) && isNotEmpty(orderLineDto.delivery_request_date_input)){
            checkDeliveryPlanDate(orderLineDto);
        }else{
            setCommitConfirmMsg(`入力完了を実施します。よろしいでしょうか？\n※入力完了後、データの変更はできません。`);
            setShowCommitConfirmModal(true);
        }
    }

    const checkDeliveryPlanDate = (orderLineDto : OrderInputLineDto) => {
        showLoading();
        post<OrderInputLineDto>({
            action: "/api/order/delivery/plan_date",
            data: orderLineDto,
        })
            .then((data) => {
                if(data && isBeforeDate(data.delivery_plan_date, data.delivery_request_date_input) ) {
                    setCommitConfirmMsg(`最短お届け日が${data.delivery_plan_date}になります。\n入力完了を実施します。よろしいでしょうか？\n※入力完了後、データの変更はできません。`);
                }else {
                    setCommitConfirmMsg(`入力完了を実施します。よろしいでしょうか？\n※入力完了後、データの変更はできません。`);
                }
                setShowCommitConfirmModal(true);
            })
            .catch((reason) => {
                console.log(reason);
            })
            .finally(() => {
                hideLoading();
            });
    }

    const handleCommitYes = () => {
        setShowCommitConfirmModal(false);
        commitOrder(commitOrderLineDto);
    }

    const commitOrder = (commitDto : OrderInputLineDto | null) => {
        if(commitDto == null){
            return;
        }
        showLoading();
        post<any>({
            action: "/api/order/input/commit",
            data: {commit_input_dto: commitDto, send_mail: sendMailOnCommit},
        })
            .then((data) => {
                if(data) {
                    setOrderList(data["order_line_list"]);
                }
                toast.success("データ入力完了を正常に登録しました。");
            })
            .catch((reason) => {
                // @ts-ignore
                setErrorList([reason.message]);
            })
            .finally(() => {
                hideLoading();
            });
    }

    const handleDeliveryDateTimeChange = (idx: number, date: string, timeCode: string)=> {
        const newOrderLineDtos = [...orderList];
        newOrderLineDtos[idx] = {
            ...newOrderLineDtos[idx],
            delivery_request_date_input: date,
            delivery_request_time_code: timeCode
        }
        const isReload = hasDuplicateDelivery(newOrderLineDtos, idx);
        if(!isReload){
            setOrderList(newOrderLineDtos);
        }
        updateRequestDeliveryDateTime(newOrderLineDtos[idx], isReload);
    };

    const updateRequestDeliveryDateTime = (orderLineDto: OrderInputLineDto, isReload: boolean)=> {
        if(orderLineDto && orderLineDto.detail_list && orderLineDto.detail_list.length !== 0){
            showLoading();
            post<OrderInputLineDto>({
                action: "/api/order/delivery/update_request_datetime",
                data: orderLineDto,
            })
                .then(() => {
                    if(isReload){
                        initPage();
                    }
                })
                .catch((reason) => {
                    console.log(reason);
                })
                .finally(() => {
                    hideLoading();
                });
        }
    }

    const hasDuplicateDelivery = (orderLineList: OrderInputLineDto[], currentIndex: number): boolean => {
        const target = orderLineList[currentIndex];
        if(!target) return false;
        return orderLineList.some((dto, idx) => {
            return (
                idx !== currentIndex &&
                dto.paper_item_type &&
                !dto.committed &&
                dto.destination_name === target.destination_name &&
                dto.operator_name === target.operator_name &&
                dto.delivery_zipcode1 === target.delivery_zipcode1 &&
                dto.delivery_zipcode2 === target.delivery_zipcode2 &&
                dto.delivery_prefecture_name === target.delivery_prefecture_name &&
                dto.delivery_address1 === target.delivery_address1 &&
                dto.delivery_address2 === target.delivery_address2 &&
                dto.delivery_request_date_input === target.delivery_request_date_input &&
                dto.delivery_request_time_code === target.delivery_request_time_code
            );
        });
    }

    return(
        <Layout page_meta = {{title: '未発送のご注文｜ギフトアレンジ'}}
                breadcrumb_list={breadcrumbList}
                error_list={errorList}
                handleClickUpdateOrder={handleClickUpdate}
        >
            <section className="order-list-page-title">
                <h2>
                    未発送のご注文
                </h2>
                <p className="page-explain">
                    登録したマイデザインをご注文の商品毎に割当、<br/>
                    <span>【入力完了】ボタン</span>を必ず押してください。<br />
                    <span className="explain-sub1">
                        <strong>※熨斗・包装紙とPNGタイプは入力完了ボタンが押されるまで出荷準備ができませんのでお早めに設定をお願いします。</strong>
                    </span>
                    <br />
                    <span className="explain-sub1">
                        <strong>※オンラインメッセージのみの場合は入力完了は不要です。</strong>
                    </span>
                </p>
            </section>
            <section className="order-list-input-area">
                {orderList && orderList.length != 0 && orderList.map((orderDto, index) =>
                    <div className="order-line-view" key={`order_line_view_${index}`}>
                        {orderDto.png_type && <div className="delivery-view-block qr-gift">
                            <div className="png-title">
                                <span><img src={url("/images/common/qr_gift.png")}/></span>
                                QRギフト
                            </div>
                            <dl className="delivery-address">
                                <dt></dt><dd></dd>
                            </dl>
                            <Button variant="secondary" className="btn-input-commit" disabled={orderDto.committed} onClick={() => {onClickCommit(orderDto)}}>入力完了</Button>
                        </div>}
                        {(orderDto.eselect_type || orderDto.egift_type) && <div className="delivery-view-block online-gift">
                            <div className="png-title">
                                <span><img src={url("/images/common/online_gift.png")}/></span>
                                オンラインギフト
                            </div>
                        </div>}
                        {orderDto.paper_item_type && <div className="delivery-view-block">
                            <dl>
                                <dt>お届け先</dt>
                                <dd>{orderDto.destination_name}{orderDto.operator_name}</dd>
                            </dl>
                            <dl className="delivery-address">
                                <dt>〒{orderDto.delivery_zipcode1}-{orderDto.delivery_zipcode2}</dt>
                                <dd>{orderDto.delivery_prefecture_name}{orderDto.delivery_address1}　<br/>
                                    {orderDto.delivery_address2}</dd>
                            </dl>
                            {!isRakutenSiteSection(loginDto?.site_section) && <>
                                {!orderDto.committed ? (
                                    <DeliveryDateTimeInput
                                        title={"お届け希望日時"}
                                        orderLineDto={orderDto}
                                        handleChange={(date, time) => handleDeliveryDateTimeChange(index, date, time)}
                                    />) : (
                                    <div>
                                        <dl className="delivery-request-date">
                                            <dt>お届け希望日時</dt>
                                            <dd>{orderDto.delivery_request_text}</dd>
                                        </dl>
                                        <dl className="delivery-plan-date">
                                            <dt>お届け予定日時</dt>
                                            <dd className={isBeforeDate(orderDto.delivery_plan_date, orderDto.delivery_request_date)? "later-request": ""}>
                                                {orderDto.delivery_plan_text}
                                            </dd>
                                        </dl>
                                        {isBeforeDate(orderDto.delivery_plan_date, orderDto.delivery_request_date) && (
                                            <p className="delivery-date-note">※ご希望どおりにお届けできない恐れがあります</p>
                                        )}
                                    </div>
                                )}
                            </>}
                            <Button
                                variant="secondary"
                                className="btn-input-commit"
                                disabled={orderDto.committed} onClick={() => {onClickCommit(orderDto)}}
                            >
                                入力完了
                            </Button>
                        </div>}
                        {!isMobile && <div className="ship-view-block">
                            <div className="flex-fill">
                                <p>
                                    {orderDto.paper_item_type && <>
                                        ※オンラインメッセージは、発送後も【過去のご注文】から割り当て可能。
                                        <br/>※マイデザインを割り当てて「入力完了」をすると発送準備に取り掛かります。
                                    </>}
                                    {orderDto.png_type && <>
                                        ※オンラインメッセージは、発送後も【過去のご注文】から割り当て可能。
                                        <br/>※QRコードとPCからアクセスできるようにURLと受付IDが表示されています。
                                    </>}
                                    {(orderDto.eselect_type || orderDto.egift_type) && <>
                                        ※オンラインメッセージは、いつも割り当て可能。
                                    </>}
                                </p>
                            </div>
                            <dl className="order-template-title-area">
                                <dt>{orderDto.paper_item_type && <>のし・包装</>}</dt>
                                <dt>
                                    {orderDto.paper_item_type && <>オリジナルカード</>}
                                    {orderDto.png_type && <>QRギフトフォーマット</>}
                                </dt>
                                <dt>オンライン・<br/>メッセージ（無料）</dt>
                            </dl>
                        </div>}
                        {orderDto.detail_list && orderDto.detail_list.length != 0 && orderDto.detail_list.map(dtl =>
                            <React.Fragment key={`order_dtl_view_${dtl.slipnumber}_${dtl.detailnumber}`}>
                            <div className="order-detail-view">
                                {!isMobile && <div className="goods-image">
                                    <Image src={`${isNotEmpty(dtl.image_path)? img(dtl.image_path) : url('/images/common/list_noimage.png')}`} fluid></Image>
                                </div>}
                                <div className="flex-fill order-detail-info">
                                    <div className={`goods-info ${(orderDto.egift_type || orderDto.eselect_type)?'online-gift':''}`}>
                                        <p><strong>{dtl.goods_name}</strong></p>
                                        <p>
                                            {dtl.goods_code}
                                            <strong className="float-end send-type-name">{dtl.gift_send_type_name}</strong>
                                        </p>
                                    </div>
                                    <div className="order-numbers">
                                        <p>
                                            <span>注文番号</span><br className="sp"/>
                                            {dtl.slipnumber}
                                        </p>
                                        {dtl.rakuten_order && <p>
                                            <span className="rakuten-mask">楽天</span><br className="sp"/>
                                            {dtl.ext_order_number}
                                        </p>}
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <dl className="justify-content-start">
                                            <dt>注文日</dt>
                                            <dd>{dtl.order_date}</dd>
                                        </dl>
                                        <dl>
                                            <dt>数量</dt>
                                            <dd>{dtl.quant}</dd>
                                        </dl>
                                        <dl>
                                            <dt>購入額</dt>
                                            <dd>{dtl.sale_price_amount}円</dd>
                                        </dl>
                                    </div>
                                    {orderDto.png_type && <OrderPngDownload dtl={dtl}/>}
                                </div>
                                <div className="order-template-area">
                                    {isMobile && <>
                                        <dl className="order-template-sp">
                                            <dt className="flex-fill">
                                                オンライン・<br/>メッセージ（無料）<br/>
                                                <p>※オンラインメッセージは、発送後も【過去のご注文】から割り当て可能。</p>
                                            </dt>
                                            <dd>
                                                {dtl.message_template_dto &&
                                                    <OrderDetailTemplate dto={dtl.message_template_dto}
                                                                         committed={dtl.committed}
                                                                         handleClick={handleClickDetailTemplate}
                                                                         handleClickEntry={handleClickEntryMyDesign}
                                                    />}
                                                {dtl.message_template_dto &&
                                                    isNotEmpty(dtl.message_template_dto.apply_goods_preview_url) &&
                                                    <a href={dtl.message_template_dto.apply_goods_preview_url}
                                                       className="apply-site-preview"
                                                       target="_blank"
                                                    >交換サイト表示</a>
                                                }
                                            </dd>
                                        </dl>
                                        {(dtl.wrapping || dtl.noshi_template_dto) &&
                                            <dl className="order-template-sp">
                                                <dt>
                                                    のし・包装<br/>
                                                    <p>※マイデザインを割り当てて「入力完了」をすると発送準備に取り掛かります。</p>
                                                </dt>
                                                <dd>
                                                    <OrderDetailTemplate dto={dtl.noshi_template_dto}
                                                                         committed={dtl.committed}
                                                                         handleClick={handleClickDetailTemplate}
                                                                         handleClickEntry={handleClickEntryMyDesign}
                                                    />
                                                </dd>
                                            </dl>}
                                        {(dtl.ondemand_card || dtl.card_template_dto) &&
                                            <dl className="order-template-sp">
                                                <dt>
                                                    オリジナル<br/>カード<br/>
                                                    <p>※マイデザインを割り当てて「入力完了」をすると発送準備に取り掛かります。</p>
                                                </dt>
                                                <dd>
                                                    <OrderDetailTemplate dto={dtl.card_template_dto}
                                                                         committed={dtl.committed}
                                                                         handleClick={handleClickDetailTemplate}
                                                                         handleDeallocated={handleDeallocatedTemplate}
                                                                         handleClickEntry={handleClickEntryMyDesign}
                                                    />
                                                </dd>
                                            </dl>}
                                        {isQrType(dtl.gift_send_type_code) && dtl.qr_template_dto &&
                                            <dl className="order-template-sp">
                                                <dt>
                                                    QRギフト<br/>フォーマット<br/>
                                                    <p>※QRコードとPCからアクセスできるようにURLと受付IDが表示されています。</p>
                                                </dt>
                                                <dd>
                                                    <OrderDetailTemplate dto={dtl.qr_template_dto}
                                                                         committed={dtl.committed}
                                                                         seal_type={isSealType(dtl.gift_send_type_code)}
                                                                         handleClick={handleClickDetailTemplate}
                                                    />
                                                </dd>
                                            </dl>}
                                    </>}
                                    {!isMobile && <dl className="order-template-pc">
                                        <dd>
                                            {(dtl.wrapping || dtl.noshi_template_dto) &&
                                                <OrderDetailTemplate dto={dtl.noshi_template_dto}
                                                                     committed={dtl.committed}
                                                                     handleClick={handleClickDetailTemplate}
                                                                     handleClickEntry={handleClickEntryMyDesign}
                                                />}
                                        </dd>
                                        <dd>
                                            {(dtl.ondemand_card || dtl.card_template_dto) &&
                                                <OrderDetailTemplate dto={dtl.card_template_dto}
                                                                     committed={dtl.committed}
                                                                     handleClick={handleClickDetailTemplate}
                                                                     handleDeallocated={handleDeallocatedTemplate}
                                                                     handleClickEntry={handleClickEntryMyDesign}
                                                />}
                                            {isQrType(dtl.gift_send_type_code) && dtl.qr_template_dto &&
                                                <OrderDetailTemplate dto={dtl.qr_template_dto}
                                                                     committed={dtl.committed}
                                                                     seal_type={isSealType(dtl.gift_send_type_code)}
                                                                     handleClick={handleClickDetailTemplate}
                                                />}
                                        </dd>
                                        <dd>
                                            {dtl.message_template_dto &&
                                                <OrderDetailTemplate dto={dtl.message_template_dto}
                                                                     committed={dtl.committed}
                                                                     handleClick={handleClickDetailTemplate}
                                                                     handleClickEntry={handleClickEntryMyDesign}
                                                />
                                            }
                                        </dd>
                                    </dl>}
                                </div>
                            </div>
                            {orderDto.eselect_type && <OrderUrlSendHistory dtl={dtl}/>}
                            </React.Fragment>)}
                    </div>
                )}
            </section>
            <br/>
            <section className="my-design-intro">
                <dl className="content-dl">
                    <dt>
                        マイデザインの種類<br/>
                        <p>ご希望のマイデザインを制作して<br/>
                            ご注文いただいたオンラインギフトに<br/>
                            割り当てると発送されます。<br/>
                        </p>
                    </dt>
                    <dd className="template-types">
                        <div className="template-type-item">
                            <div className="picture">
                                <Image src={url("/images/top/online_message_pic.png")} fluid></Image>
                            </div>
                            <dl>
                                <dt>オンラインメッセージ</dt>
                                <dd></dd>
                            </dl>
                        </div>
                        <div className="template-type-item">
                            <div className="picture">
                                <Image src={url("/images/top/wrap_noshi_pic.png")} fluid></Image>
                            </div>
                            <dl>
                                <dt>のし包装</dt>
                                <dd>※BOXタイプとBOOKタイプの熨斗包装を登録できます。</dd>
                            </dl>
                        </div>
                        <div className="template-type-item">
                            <div className="picture">
                                <Image src={url("/images/top/original_card_pic.png")} fluid></Image>
                            </div>
                            <dl>
                                <dt>オンデマンドカード</dt>
                                <dd>※有料オプションで、オリジナルのオンデマンドギフトカードが制作できます。</dd>
                            </dl>
                        </div>
                        <div className="template-type-item">
                            <div className="picture">
                                <Image src={url("/images/top/qr_gift_pic.png")} fluid></Image>
                            </div>
                            <dl>
                                <dt>QRフォーマット</dt>
                                <dd>※PNGタイプのフォーマットを指定します。</dd>
                            </dl>
                        </div>
                    </dd>
                </dl>
                <dl className="content-dl">
                    <dt>登録の手順</dt>
                    <dd className="input-flows">
                        <dl>
                            <dt>１.マイデザインの製作</dt>
                            <dd>
                                <p>ご希望のアレンジしたいデザインをマイデザインとして登録します。</p>
                            </dd>
                        </dl>
                        <dl>
                            <dt>２.未発送のご注文に割り当て</dt>
                            <dd>
                                <p>
                                    <Link style={{textDecoration: 'none'}}
                                          className="my-text-cyan-bold"
                                          to="/order/input">【未発送のご注文】</Link>
                                    に表示されている注文毎に作成したマイデザインを割り当て登録します。
                                </p>
                            </dd>
                        </dl>
                        <dl>
                            <dt>３.入力確定をする</dt>
                            <dd>
                                <p>
                                    <Link style={{textDecoration: 'none'}}
                                          className="my-text-cyan-bold"
                                          to="/order/input">【未発送のご注文】</Link>
                                    でマイテンプレートを割り当てたら【入力完了】をすると発送準備を開始いたします。<br/>
                                    <span>※熨斗・包装紙とPNGタイプは入力完了ボタンが押されるまで出荷準備ができませんのでお早めに設定をお願いします。</span>
                                </p>
                            </dd>
                        </dl>
                        <dl>
                            <dt>４.オンラインメッセージの編集</dt>
                            <dd>
                                <p>
                                    オンラインメッセージは、発送後でも
                                    <Link style={{textDecoration: 'none', color : '#555555'}}
                                          className="my-text-bold"
                                          to="/order/history">【過去のご注文】</Link>
                                    から商品を申し込むまで、マイデザインの割り当てができます。
                                </p>
                            </dd>
                        </dl>
                    </dd>
                </dl>
                <div className="d-flex justify-content-center">
                    <Button variant="info" className="btn-make-template" onClick={() => {navigate("/template");}}>
                        マイデザインの製作<span className="button-icon"><img src={url("/images/icon/pen_white_icon.png")}/></span>
                    </Button>
                </div>
                <br/><br/>
            </section>
            <section>
                <TemplateListModal
                    show={showTempListModal}
                    search_dto={searchTemplateDto}
                    handleSelected={handleSelectedTemplate}
                    handleClosed={() => {setSearchTemplateDto(undefined)}}
                />
                <QrFormatSettingModal
                    dto={selectedQrSettingDto}
                    show={showQrSettingModal}
                    handleSaved={handleQrSettingSaved}
                    handleClosed={() => {setSelectedQrSettingDto(undefined)}}
                />
                <ProcessConfirmModal
                    message={commitConfirmMsg}
                    show={showCommitConfirmModal} handleNo={()=>{setShowCommitConfirmModal(false)}}
                    handleYes={handleCommitYes}
                    checkboxLabel="入力完了メールを送信する。"
                    checkboxChecked={sendMailOnCommit}
                    onCheckboxChange={setSendMailOnCommit}
                />
            </section>
        </Layout>
    );
};
export default OrderInputListPage;